/**
 * @fileoverview Numeric formatting for prediction displays and printed reports.
 * Keeps presentation rounding separate from stored scores and probabilities used in calculations.
 *
 * @module prediction-display-helpers
 */

/**
 * Round a prediction value to one decimal place for display.
 * Returns a number so whole values have no trailing decimal. Callers add their own units.
 * Use the original value for calculations, grading and storage.
 *
 * @param {number} value - Finite score, margin or percentage to present
 *
 * @return {number} Rounded display value without changing the source prediction
 * @example
 * formatPredictionValue(57.4321); // 57.4
 * formatPredictionValue(24); // 24
 */
export const formatPredictionValue = (value: number): number => Number(value.toFixed(1));
